import addAchievFunction from "./achievsActions";

const getCountryInfo = (code, name) => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' });
    try {
      const db = getFirestore()
      const countryRequest = await fetch(`https://restcountries.eu/rest/v2/alpha?codes=${code}`)
      const countryData = await countryRequest.json()
      const countryDoc = await db.collection('countries').doc(name).get()
      const countryDocData = await countryDoc.data();

      dispatch({ type: 'COUNTRY_DATA_SUCCESS', payload: { country: countryData[0], countryDoc: countryDocData } })
    } catch (err) {
      dispatch({ type: 'COUNTRY_DATA_ERROR', payload: err.message })
    }
  }
}

const getCountryDoc = (name) => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' });
    try {
      const db = getFirestore()
      const countryDoc = await db.collection('countries').doc(name).get()
      const countryDocData = await countryDoc.data();

      dispatch({ type: 'COUNTRY_DOC_SUCCESS', payload: countryDocData })
    } catch (err) {
      dispatch({ type: 'COUNTRY_DOC_ERROR', payload: err.message })
    }
  }
}

/* const changeLanguageCountryNews = (country, lang) => {
  return async (dispatch) => {
    dispatch({ type: 'API_REQUEST_START' });
    try {
      let newsRequest = await fetch(`https://newsapi.org/v2/everything?qInTitle=${country}&from=2020-04-10&sortBy=publishedAt&language=${lang}&apiKey=a303f44f820d40cb85260fb4e327995b`)
      let newsData = await newsRequest.json();
      dispatch({ type: 'COUNTRY_DATA_SUCCESS', payload: newsData.articles })
    } catch (err) {
      dispatch({ type: 'COUNTRY_DATA_ERROR', payload: err.message })
    }
  }
} */

/* const getNews = (keyWords) => {
  return async (dispatch) => {
    dispatch({ type: 'API_REQUEST_START' });
    try {
      const request = await fetch(
        `https://newsapi.org/v2/everything?q=${keyWords}&sortBy=publishedAt&apiKey=a303f44f820d40cb85260fb4e327995b`
      )
      const data = await request.json();
      dispatch({ type: 'NEWS_DATA_SUCCESS', payload: data })
    } catch (err) {
      dispatch({ type: 'NEWS_DATA_ERROR', payload: err.message })
    }
  }
}
 */
const getUsers = (action, input, order, orderType) => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' })
    const db = getFirestore()
    const getLastUser = getState().apiCalls.apiData.allUsers.lastUser
    const getFirstUser = getState().apiCalls.apiData.allUsers.firstUser
    let currentPage = getState().apiCalls.apiData.allUsers.page

    try {
      if (action === 'previous') {
        let previousUsers

        if (!orderType && !input) {
          previousUsers = await db.collection('users')
            .orderBy("createdAt", "desc")
            .endBefore(getFirstUser)
            .limitToLast(12)
        } else if (input && orderType === 'search-name') {
          previousUsers = await db.collection('users')
            .where('username', '==' `${input}`)
            .endBefore(getFirstUser)
            .limitToLast(12)
        } else {
          previousUsers = await db.collection('users')
            .orderBy(`${order}`, `${orderType}`)
            .endBefore(getFirstUser)
            .limitToLast(12)
        }

        const returnPreviousUsers = []
        const getPreviousUsers = await previousUsers.get()
        let firstItem = getPreviousUsers.docs[0].ref
        let lastItem = getPreviousUsers.docs[getPreviousUsers.docs.length - 1].ref
        let updatePage = currentPage -= 1
        getPreviousUsers.docs.forEach((item) => {
          let docInfo = item.data()
          returnPreviousUsers.push(docInfo)
        })

        dispatch({ type: 'GET_USERS_SUCCESS', payload: returnPreviousUsers, lastUser: lastItem, firstUser: firstItem, page: updatePage })
      } else if (action === 'next') {
        console.log('teste')

        let nextUsers
        if (!orderType && !input) {
          console.log('olá')
          nextUsers = await db.collection('users')
            .orderBy("createdAt", "desc")
            .startAfter(getLastUser)
            .limit(12)
        } else if (input && orderType === 'search-name') {
          nextUsers = await db.collection('users')
            .where('username', '==' `${input}`)
            .startAfter(getLastUser)
            .limit(12)
        } else {
          nextUsers = await db.collection('users')
            .orderBy(`${order}`, `${orderType}`)
            .startAfter(getLastUser)
            .limit(12)
        }

        const getNextUsers = await nextUsers.get()
        let firstItem = getNextUsers.docs[0]
        let lastItem = getNextUsers.docs[getNextUsers.docs.length - 1]
        let updatePage = currentPage += 1

        const returnNextUsers = []
        getNextUsers.docs.forEach((item) => {
          let docInfo = item.data()
          returnNextUsers.push(docInfo)
        })

        dispatch({ type: 'GET_USERS_SUCCESS', payload: returnNextUsers, lastUser: lastItem, firstUser: firstItem, page: updatePage })
      } else if (action === 'initial') {

        const getInitialUser = await db.collection('users')
          .orderBy("createdAt", "desc")
          .limit(12)

        const getInitialUserData = await getInitialUser.get()
        let firstItem = getInitialUserData.docs[0]
        let lastItem = getInitialUserData.docs[getInitialUserData.docs.length - 1]

        const getInitialUserReturn = []
        getInitialUserData.docs.forEach((item) => {
          let docInfo = item.data()
          getInitialUserReturn.push(docInfo)
        })

        dispatch({ type: 'GET_USERS_SUCCESS', payload: getInitialUserReturn, lastUser: lastItem, firstUser: firstItem, page: 1 })
      } else {
        const getInitialUser = await db.collection('users')
          .where('username', '==' `${input}`)
          .orderBy("createdAt", "desc")
          .limit(12)

        const getInitialUserData = await getInitialUser.get()
        let firstItem = getInitialUserData.docs[0]
        let lastItem = getInitialUserData.docs[getInitialUserData.docs.length - 1]

        const getInitialUserReturn = []
        getInitialUserData.docs.forEach((item) => {
          let docInfo = item.data()
          getInitialUserReturn.push(docInfo)
        })

        dispatch({ type: 'GET_USERS_SUCCESS', payload: getInitialUserReturn, lastUser: lastItem, firstUser: firstItem, page: 1 })
      }
    } catch (err) {
      dispatch({ type: 'GET_USERS_ERROR', error: err })
    }
  }
}

/* const sendAchievements = (object) => {
  return async (dispatch, getState, { getFirestore }) => {
    const db = getFirestore()
    console.log(object)
    try {
      await db.collection('achievements').doc("achievements").update({
        achievs: object
      })
      dispatch({ type: 'GET__ACHIEVS_SUCCESS' })
    } catch (err) {
      console.log(err)
      dispatch({ type: 'GET__ACHIEVS_ERROR', error: err })
    }
  }
} */

const getLockedAchievements = () => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' })
    const userAchievements = getState().firebase.profile.achievements
    const db = getFirestore()
    try {
      const allAchievs = await db.collection('achievements').doc("achievements").get()
      const allAchievsData = await allAchievs.data()
      console.log(allAchievsData)
      let returnLockedAchievs

      if (userAchievements.length !== 0) {
        returnLockedAchievs = allAchievsData.achievs.filter(achiev => !userAchievements.includes(achiev.name))
      } else {
        returnLockedAchievs = allAchievsData.achievs
      }

      dispatch({ type: 'GET_LOCKED_ACHIEVS_SUCCESS', payload: returnLockedAchievs })
    } catch (err) {
      dispatch({ type: 'GET_LOCKED_ACHIEVS_ERROR', error: err })
    }
  }
}

const getSpecificUser = (user) => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' })
    const db = getFirestore()
    try {
      const users = await db.collection('users').where("username", "==", user).get()
      var returnData = [];
      users.docs.forEach(doc => {
        let docInfo = doc.data()
        returnData.push(docInfo)
      });
      dispatch({ type: 'GET_USER_SUCCESS', payload: returnData[0] })
    } catch (err) {
      dispatch({ type: 'GET_USER_ERROR', error: err })
    }
  }
}

const getOwnUser = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: 'GET_OWN_USER_SUCCESS' })
    } catch (err) {
      dispatch({ type: 'GET_OWN_USER_SUCCESS', error: err })
    }
  }
}

const updateFavoriteCountry = (country, action) => {
  return async (dispatch, getState, { getFirestore }) => {
    const db = getFirestore()
    const uid = getState().firebase.auth.uid
    const userCountries = getState().firebase.profile.favoriteCountries

    if (action) {
      userCountries.push({
        name: country.name,
        img: country.flag
      })
    } else {
      let findIndex = userCountries.findIndex(item => {
        return item.name === country.name
      })
      userCountries.splice(findIndex, 1);
    }

    try {
      await db.collection('users').doc(uid).update({
        favoriteCountries: userCountries
      })
      dispatch({ type: 'UPDATE_COUNTRY_SUCCESS', payload: action })
    } catch (err) {
      console.log(err)
      dispatch({ type: 'UPDATE_COUNTRY_ERROR', error: err })
    }
  }
}

// UPDATE MATILDE NOTIF VALUE IN USER DOCUMENT
const updateMatildeNotif = (value) => {
  return async (dispatch, getState, { getFirestore }) => {
    const db = getFirestore()
    const uid = getState().firebase.auth.uid

    try {
      await db.collection('users').doc(uid).update({
        matildeNotif: value
      })

      dispatch({ type: 'UPDATE_MATILDE_NOTIF_SUCCESS' })
    } catch (err) {
      dispatch({ type: 'UPDATE_MATILDE_NOTIF_ERROR', error: err })
    }
  }
}

// UPDATE USER AVATAR VALUE IN USER DOCUMENT
const updateAvatar = (expression, hat) => {
  return async (dispatch, getState, { getFirestore }) => {
    const db = getFirestore()
    const uid = getState().firebase.auth.uid

    try {
      await db.collection('users').doc(uid).update({
        avatar: hat ? `matilde-${hat}-${expression}` : `matilde-${expression}`
      })

      dispatch({ type: 'UPDATE_MATILDE_AVATAR_SUCCESS' })
    } catch (err) {
      dispatch({ type: 'UPDATE_MATILDE_AVATAR_ERROR', error: err })
    }
  }
}

/* const getAdvices = () => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' })
    const db = getFirestore()

    try {
      let recentAdvices = await db.collection('advices').orderBy("date").limit(12)
      dispatch({ type: 'GET_ADVICES_SUCCESS', payload: recentAdvices })
    } catch (err) {
      dispatch({ type: 'GET_ADVICES_ERROR', error: err })
    }
  }
} */

const setAdvice = (content) => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' })

    var format = /[`@#$%^&*_\\[\]{}\\|<>\/~]/

    if (content === '' || !content) {
      dispatch({ type: 'SET_ADVICE_ERROR', error: { length: 'Não foi possível submeter o comentário já que este está vazio' } })
    } else if (content.length >= 250 && format.test(content)) {
      dispatch({
        type: 'SET_ADVICE_ERROR', error: {
          length: 'Não foi possível submeter o conselho, o número de palavras/caracteres de 250 foi atingido!',
          character: 'Não foi possível submeter o conselho já que existem símbolos especiais no mesmo'
        }
      })
    } else if (content.length >= 250) {
      dispatch({ type: 'SET_ADVICE_ERROR', error: { length: 'Não foi possível submeter o conselho, o número de palavras/caracteres de 250 foi atingido!' } })
    } else if (format.test(content)) {
      dispatch({ type: 'SET_ADVICE_ERROR', error: { character: 'Não foi possível submeter o conselho já que existem símbolos especiais no mesmo' } })
    } else {
      const db = getFirestore()
      const getUser = getState().firebase.profile.username
      const getAvatar = getState().firebase.profile.avatar
      const getUserUid = getState().firebase.auth.uid
      const getUserAdvices = getState().firebase.profile.advices

      try {
        const advice = {
          advice: content,
          date: Date.now(),
          user: getUser,
          avatar: getAvatar,
          reactions: {
            gosto: 0,
            adoro: 0,
            divertido: 0,
            triste: 0
          }
        }

        await db.collection('advices').doc().set(advice)

        delete advice['reactions']

        await db.collection('users').doc(getUserUid).update({
          advices: getUserAdvices.concat(advice)
        })

        dispatch(addAchievFunction(['advices', 'achievements']))
        dispatch({ type: 'SET_ADVICE_SUCCESS' })
      } catch (err) {
        console.log(err)
        dispatch({ type: 'SET_ADVICE_ERROR', error: err })
      }
    }
  }
}

const setComment = (content, country) => {
  return async (dispatch, getState, { getFirestore }) => {
    dispatch({ type: 'API_REQUEST_START' })

    var format = /[`@#$%^&*_\\[\]{};':"\\|<>\/~]/

    if (content === '' || !content) {
      dispatch({ type: 'SET_COMMENT_ERROR', error: { length: 'Não foi possível submeter o comentário já que este está vazio' } })
    } else if (content.length >= 250 && format.test(content)) {
      dispatch({
        type: 'SET_COMMENT_ERROR', error: {
          length: 'Não foi possível submeter o comentário, o número de palavras/caracteres de 250 foi atingido!',
          character: 'Não foi possível submeter o comentário já que existem símbolos especiais no mesmo'
        }
      })
    } else if (content.length >= 250) {
      dispatch({ type: 'SET_COMMENT_ERROR', error: { length: 'Não foi possível submeter o comentário, o número de palavras/caracteres de 250 foi atingido!' } })
    } else if (format.test(content)) {
      dispatch({ type: 'SET_COMMENT_ERROR', error: { character: 'Não foi possível submeter o comentário já que existem símbolos especiais no mesmo' } })
    } else {
      const db = getFirestore()
      const getCurrentComments = getState().firestore.data['country']
      const userComments = getState().firebase.profile.comments
      const getUser = getState().firebase.profile.username
      const getAvatar = getState().firebase.profile.avatar
      const getUserUid = getState().firebase.auth.uid

      try {
        const comment = {
          comment: content,
          date: Date.now(),
          name: getUser,
          avatar: getAvatar,
          reactions: {
            gosto: 0,
            adoro: 0,
            divertido: 0,
            triste: 0
          }
        }

        await db.collection('countries').doc(country).update({
          comments: getCurrentComments.comments.concat(comment)
        })

        delete comment['reactions']

        await db.collection('users').doc(getUserUid).update({
          comments: userComments.concat(comment)
        })

        const updatedComments = await db.collection('countries').doc(country).get()

        dispatch(addAchievFunction(['comments', 'achievements']))
        dispatch({ type: 'SET_COMMENT_SUCCESS', payload: updatedComments.data() })
      } catch (err) {
        console.log(err)
        dispatch({ type: 'SET_COMMENT_ERROR', error: err })
      }
    }
  }
}

const updateReaction = (args) => {
  const { reaction, item, activeItem, id, type, action } = args

  console.log(item)
  console.log(activeItem)
  console.log(action)

  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: 'START_UPDATING_REACTIONS' })
    const db = getFirestore()
    const getUser = getState().firebase.auth.uid
    const getUserReactions = getState().firebase.profile.reactionItems
    const keyProperty = type === 'comments' ? 'date' : 'id'

    if (type === 'comments') {
      try {
        const getCap = getState().game.currentNarrativeObject.country
        const countryComments = await db.collection('countries').doc(getCap).get()
        const countryCommentsData = await countryComments.data()

        const objIndex = countryCommentsData.comments.findIndex((obj => obj[keyProperty] === id))
        const activeItemCountryIndex = countryCommentsData.comments.findIndex((obj => obj[keyProperty] === activeItem?.id))
        const activeItemUserIndex = getUserReactions.findIndex((obj => obj.id === activeItem?.id))

        if (action) {
          countryCommentsData.comments[objIndex].reactions[reaction]++
          if (activeItem) {
            countryCommentsData.comments[activeItemCountryIndex].reactions[activeItem?.reaction]--
            getUserReactions.splice(activeItemUserIndex, 1)
          }
          getUserReactions.push({ type: type, reaction: reaction, id: id })
        } else {
          countryCommentsData.comments[activeItemCountryIndex].reactions[activeItem?.reaction]--
          item[keyProperty] !== activeItem.id && countryCommentsData.comments[objIndex].reactions[reaction]++
          getUserReactions.splice(activeItemUserIndex, 1)
        }

        await db.collection('countries').doc(getCap).update({
          comments: [...countryCommentsData.comments]
        })

        await db.collection('users').doc(getUser).update({
          reactionItems: [...getUserReactions]
        })

        dispatch({ type: 'UPDATE_REACTION_SUCCESS' })
      } catch (err) {
        dispatch({ type: 'UPDATE_REACTION_ERROR', error: err })
      }
    } else {
      try {
        const getDoc = await db.collection(`${type}`).doc(id).get()
        const getDocData = getDoc.data()

        const activeItemUserIndex = getUserReactions.findIndex((obj => obj.id === activeItem?.id))

        if (action) {
          getDocData.reactions[reaction]++
          if (activeItem) {
            getDocData.reactions[activeItem?.reaction]--
            getUserReactions.splice(activeItemUserIndex, 1)
          }
          getUserReactions.push({ type: type, reaction: reaction, id: id })
        } else {
          getDocData.reactions[activeItem?.reaction]--
          item[keyProperty] !== activeItem.id && getDocData.reactions[reaction]++
          getUserReactions.splice(activeItemUserIndex, 1)
        }

        await db.collection(`${type}`).doc(id).update({
          reactions: { ...getDocData.reactions }
        })

        await db.collection('users').doc(getUser).update({
          reactionItems: [...getUserReactions]
        })

        dispatch({ type: 'UPDATE_REACTION_SUCCESS' })
      } catch (err) {
        console.log(err)
        dispatch({ type: 'UPDATE_REACTION_ERROR', error: err })
      }
    }
  }
}

/* const pagination = (lastVisible) => {
  return async (dispatch, getState, { getFirestore }) => {

    dispatch({ type: 'API_REQUEST_START' })
    const db = getFirestore()
    // var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];

    try {
      let users = await db.collection("users")
        .orderBy('scorePoints')
        .startAfter(lastVisible)

      console.log(users)

      dispatch({ type: 'GET_ALL_USERS_SUCCESS', payload: users })
    } catch (err) {
      dispatch({ type: 'GET_ALL_USERS_ERROR', error: err })
    }
  }
} */

export {
  getCountryInfo,
  getCountryDoc,
  getUsers,
  getOwnUser,
  getSpecificUser,
  /* getAdvices, */
  getLockedAchievements,
  updateReaction,
  updateFavoriteCountry,
  updateMatildeNotif,
  updateAvatar,
  setAdvice,
  setComment,
}